import React from 'react'

import * as styles from 'modules/resultsV2/DataAccessRequestQueryParameterSection.styles'
import type { DataAccessRequestQueryDisplayRow } from 'modules/resultsV2/hooks/getDataAccessRequestQueryDisplayRows'

interface QueryParameterSectionProps {
  title: string
  rows: DataAccessRequestQueryDisplayRow[]
  testId: string
  emptyMessage?: string
  separated?: boolean
}

export const DataAccessRequestQueryParameterSection = ({
  title,
  rows,
  testId,
  emptyMessage
}: QueryParameterSectionProps): JSX.Element | null => {
  if (rows.length === 0 && !emptyMessage) {
    return null
  }

  return (
    <styles.MetadataSubsection data-testid={testId}>
      <styles.MetadataSubsectionTitle>{title}</styles.MetadataSubsectionTitle>
      {rows.length > 0 ? (
        rows.map(row => (
          <styles.MetadataRow key={row.label}>
            <styles.MetadataLabel>{row.label}</styles.MetadataLabel>
            <styles.MetadataValue>{row.value}</styles.MetadataValue>
          </styles.MetadataRow>
        ))
      ) : (
        <styles.MetadataRow>
          <styles.MetadataLabel>Restrictions</styles.MetadataLabel>
          <styles.MetadataValue>{emptyMessage}</styles.MetadataValue>
        </styles.MetadataRow>
      )}
    </styles.MetadataSubsection>
  )
}
